import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticleGuide from "../pages/article/cssbuy-spreadsheet-guide/page";
import ShoppingGuide from "../pages/guide/shopping/page";
import TrustedSellers from "../pages/article/trusted-cssbuy-sellers/page";
import KakobuyHub from "../pages/hub/kakobuy-spreadsheet/page";
import SuperbuyHub from "../pages/hub/superbuy-spreadsheet/page";
import OopbuyHub from "../pages/hub/oopbuy-spreadsheet/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/cssbuy-spreadsheet-guide",
    element: <ArticleGuide />,
  },
  {
    path: "/guide/shopping",
    element: <ShoppingGuide />,
  },
  {
    path: "/article/trusted-cssbuy-sellers",
    element: <TrustedSellers />,
  },
  {
    path: "/hub/kakobuy-spreadsheet",
    element: <KakobuyHub />,
  },
  {
    path: "/hub/superbuy-spreadsheet",
    element: <SuperbuyHub />,
  },
  {
    path: "/hub/oopbuy-spreadsheet",
    element: <OopbuyHub />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;